import { Button, Divider } from "antd";
import { CustomModal } from "../common/CustomModal";
import * as React from "react";
import { Layout, Input, Select, Checkbox, Row } from "antd";
import { Formik } from "formik";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import styled from "styled-components";
import { MODULES, ROLES } from "../../constant/comman";
import { checkPermission } from "../AdminUser/CheckPremission";

const { Content } = Layout;
const Option = Select.Option;

const PermissionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 16px;
`;

const PermissionCard = styled.div`
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    border-color: #d9d9d9;
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
  gap: 10px;

  strong {
    font-size: 15px;
    color: #262626;
  }

  .ant-checkbox-wrapper {
    white-space: nowrap;
  }
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const GlobalToggleContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

const QuickButton = styled(Button)`
  font-size: 13px !important;
  border-radius: 4px !important;
`;

export class AddAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: [],
      view: false,
      isLoading: false,
      visible: false,
      selectedAdminType: "",
      errors: {
        selectedAdminType: "",
      },
    };
  }

  input;
  permissionsData = {};

  allTypes = [
    <Option value={"subAdmin"} key="subAdmin">
      Sub Admin
    </Option>,
    <Option value={"superAdmin"} key="superAdmin">
      Super Admin
    </Option>,
  ];

  componentDidMount() {
    //set initial permission value start
    this.setInitialPermission();
    //set initial permission value end
  }

  /**
   * set initial permission false for the sub admin user in below format for the defined modules
   * with defined actions in constant
   *
   * FORMAT: dashboard(module_name): { view(role_name): false, create: false, edit: false, delete: false },
   */
  setInitialPermission = (adminType = "subAdmin") => {
    MODULES.map((moduleName) => {
      if (ROLES[moduleName.value]) {
        ROLES[moduleName.value].map(
          (roleName) =>
          (this.permissionsData[moduleName.value] = {
            ...this.permissionsData[moduleName.value],
            [roleName.toLowerCase()]:
              adminType === "superAdmin" ? true : false,
          })
        );
      }
    });
  };

  validateForm = (values) => {
    const { selectedAdminType } = this.state;
    const errors = {};
    console.log("Validating form -- ", values);

    // if (!values.username) {
    //   errors.username = "Username is required";
    // }

    if (!values.email) {
      errors.email = "Email is required";
    } else if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        String(values.email).toLowerCase()
      )
    ) {
      errors.email = "Please enter a valid email";
    }

    if (!values.password) {
      errors.password = "Password is required";
    } else if (values.password !== "" && values.password.length < 8) {
      errors.password = "At least 8 characters required";
    }

    if (values.password !== values.confirm_password) {
      errors.confirm_password = "Password and Confirm password does not match.";
    }

    if (!values.first_name) {
      errors.first_name = "First name is required";
    }

    if (!values.last_name) {
      errors.last_name = "Last name is required";
    }

    if (!selectedAdminType) {
      errors.selectedAdminType = "Please select admin type";
    }

    console.log("Validating errors -- ", errors);

    return errors;
  };

  handleSubmit = async (values, action) => {
    const { selectedAdminType } = this.state;

    values.role = selectedAdminType;

    this.props.onSubmit(values);

    this.setState({
      visible: false,
    });
  };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
      selectedType: "",
    });
  };

  changeAdminType = (value) => {
    this.setState({
      selectedAdminType: value,
    });
    this.setInitialPermission(value);
  };

  handleToggleModule = (moduleValue, isChecked, setFieldValue, values) => {
    const roles = ROLES[moduleValue] || [];
    const modulePermissions = { ...(values.permissions && values.permissions[moduleValue]) };
    roles.forEach((roleName) => {
      modulePermissions[roleName.toLowerCase()] = isChecked;
    });
    setFieldValue(`permissions.${moduleValue}`, modulePermissions);
  };

  handleToggleAll = (isChecked, setFieldValue, values) => {
    const updatedPermissions = { ...values.permissions };
    MODULES.filter((m) => m.value !== "dashboard").forEach((moduleName) => {
      const roles = ROLES[moduleName.value] || [];
      updatedPermissions[moduleName.value] = { ...updatedPermissions[moduleName.value] };
      roles.forEach((roleName) => {
        updatedPermissions[moduleName.value][roleName.toLowerCase()] = isChecked;
      });
    });
    setFieldValue("permissions", updatedPermissions);
  };

  isModuleAllChecked = (moduleValue, values) => {
    const roles = ROLES[moduleValue] || [];
    if (!values.permissions || !values.permissions[moduleValue]) return false;
    return roles.every((roleName) => values.permissions[moduleValue][roleName.toLowerCase()]);
  };

  render() {
    const { primaryColor, LoginData } = this.props;
    const { subAdminType } = this.state;
    const canAdd = checkPermission(LoginData, "admin", "create");

    return (
      <div>
        <div
          onClick={canAdd ? this.showModal : null}
          style={{
            width: "100px",
            backgroundColor: primaryColor,
            color: "white",
            padding: "7px 0px",
            textAlign: "center",
            borderRadius: "50px",
            cursor: canAdd ? "pointer" : "not-allowed",
            opacity: canAdd ? 1 : 0.5,
            pointerEvents: canAdd ? "auto" : "none",
          }}
        >
          ADD
        </div>

        <CustomModal
          destroyOnClose={true}
          title="Add Admin"
          visible={this.state.visible}
          onCancel={this.handleCancel}
          footer={null}
          maskClosable={false}
        >
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                // username: "",
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                password: "",
                confirm_password: "",
                role: "",
                permissions: this.permissionsData,
              }}
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
              }) => {
                return (
                  <div>
                    <div className="formik-field_wrap">
                      {/* <div className="formik-field-left">
                        Username
                        <Input
                          id="username"
                          placeholder="Username"
                          value={values.username}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.username && touched.username ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.username}
                          </p>
                        ) : null}
                      </div> */}

                      <div className="formik-field-left">
                        First Name
                        <Input
                          id="first_name"
                          placeholder="First Name"
                          value={values.first_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.first_name && touched.first_name ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.first_name}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Last Name
                        <Input
                          id="last_name"
                          placeholder="Last Name"
                          value={values.last_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.last_name && touched.last_name ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.last_name}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Email
                        <Input
                          id="email"
                          placeholder="Email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.email && touched.email ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.email}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Admin Type
                        <select
                          id="role"
                          style={{
                            width: "100%",
                            height: "38px",
                            borderRadius: "5px",
                            border: "1px solid #d9d9d9",
                            padding: "0 11px",
                            outline: "none",
                            backgroundColor: "#fff",
                            cursor: "pointer",
                          }}
                          value={this.state.selectedAdminType || ""}
                          onChange={(e) => {
                            const val = e.target.value;
                            this.changeAdminType(val);
                            setFieldValue("permissions", this.permissionsData);
                          }}
                        >
                          <option value="" disabled>Select Admin Type</option>
                          <option value="subAdmin">Sub Admin</option>
                          <option value="superAdmin">Super Admin</option>
                        </select>
                        {errors.selectedAdminType ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.selectedAdminType}
                          </p>
                        ) : null}
                      </div>

                      {/* <div className="formik-field-right">
                        Phone
                        <Input
                          id="phone"
                          placeholder="Phone"
                          value={values.phone || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.phone && touched.phone ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.phone}
                          </p>
                        ) : null}
                      </div> */}
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Password
                        <Input
                          type="password"
                          id="password"
                          placeholder="Password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.password && touched.password ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.password}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Confirm Password
                        <Input
                          id="confirm_password"
                          type="password"
                          placeholder="Confirm Password"
                          value={values.confirm_password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.confirm_password && touched.confirm_password ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.confirm_password}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      {/* <div className="formik-field-left">
                        Admin Type
                        <Select
                          allowClear
                          style={{ width: "100%" }}
                          onChange={(value) => this.changeAdminType(value)}
                          placeholder="Select Admin Type"
                          showSearch
                          // defaultValue="subAdmin"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {this.allTypes}
                        </Select>
                        {errors.selectedAdminType ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.selectedAdminType}
                          </p>
                        ) : null}
                      </div> */}
                    </div>

                     {this.state.selectedAdminType === "subAdmin" && (
                      <div style={{ marginTop: "24px" }}>
                        <div style={{ marginBottom: "8px" }}>
                          <strong style={{ fontSize: "16px", color: "#333" }}>Permissions Configuration</strong>
                        </div>
                        <GlobalToggleContainer>
                          <QuickButton
                            size="small"
                            onClick={() => this.handleToggleAll(true, setFieldValue, values)}
                            style={{ background: "#f5f5f5", borderColor: "#d9d9d9", color: "#595959" }}
                          >
                            Grant All Permissions
                          </QuickButton>
                          <QuickButton
                            size="small"
                            onClick={() => this.handleToggleAll(false, setFieldValue, values)}
                            style={{ background: "#f5f5f5", borderColor: "#d9d9d9", color: "#595959" }}
                          >
                            Revoke All Permissions
                          </QuickButton>
                        </GlobalToggleContainer>
                        <PermissionsGrid>
                          {MODULES.filter((m) => m.value !== "dashboard").map((moduleName, moduleIndex) => {
                            const allChecked = this.isModuleAllChecked(moduleName.value, values);
                            return (
                              <PermissionCard key={moduleIndex}>
                                <CardHeader>
                                  <strong>{moduleName.label}</strong>
                                  <Checkbox
                                    checked={allChecked}
                                    onChange={(e) => this.handleToggleModule(moduleName.value, e.target.checked, setFieldValue, values)}
                                    style={{ fontSize: "12px", color: "#8c8c8c" }}
                                  >
                                    Select All
                                  </Checkbox>
                                </CardHeader>
                                <CardBody>
                                  {ROLES[moduleName.value] && ROLES[moduleName.value].map(
                                    (roleName, roleIndex) => (
                                      <div key={roleIndex}>
                                        <Checkbox
                                          onChange={handleChange}
                                          checked={
                                            values.permissions &&
                                            values.permissions[moduleName.value] &&
                                            values.permissions[moduleName.value][
                                              roleName.toLowerCase()
                                            ]
                                          }
                                          name={`permissions.${moduleName.value}.${roleName.toLowerCase()}`}
                                        >
                                          {roleName}
                                        </Checkbox>
                                      </div>
                                    )
                                  )}
                                </CardBody>
                              </PermissionCard>
                            );
                          })}
                        </PermissionsGrid>
                      </div>
                    )}

                    <Button
                      type="primary"
                      style={{
                        marginTop: "19px",
                        background: "#5C6AC4",
                        color: "#fff",
                      }}
                      onClick={handleSubmit}
                    >
                      Add
                    </Button>
                  </div>
                );
              }}
            </Formik>
          </Content>
        </CustomModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
});

export default connect(mapStateToProps)(withRouter(AddAdmin));
